import CancelIcon from '@mui/icons-material/Cancel';
import { Button, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { iconDelete, iconEdit } from 'Assets/index';
import ConfirmDialog from 'Components/ConfirmDialog';
import LightTooltip from 'Components/LightTooltip/LightTooltip';
import { t } from 'i18next';
import { useState } from 'react';
import { useApproverForm } from '../../../features/approver/useApproverForm';

const ApproverListTableBody = ({
  handleEdit,
  rowsData,
  sortedRows,
  emptyRows,
  page,
  rowsPerPage,
  rowsHead,
  setPage
}) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { handleDelete } = useApproverForm(() => setPage(0));

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setDeleteDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDeleteDialogOpen(false);
    setSelectedRow(null);
  };

  const handleDialogConfirm = async () => {
    if (selectedRow) {
      try {
        await handleDelete(selectedRow?.originalData?.tags);
        handleDialogClose();
      } catch {
        handleDialogClose();
      }
    }
  };

  const renderCellContent = (column, row) => {
    if (column.id === 'approverAction') {
      return (
        <TableCell key={column.id} className="approver-management-table-cell">
          <Typography className="action-cell">
            <Button className="action-button edit-button" onClick={() => handleDeleteClick(row)}>
              <img src={iconDelete} alt="delete Icon" />
              {t('approverManagement.delete')}
            </Button>
            <Button className="action-button edit-button" onClick={() => handleEdit(row)}>
              <img src={iconEdit} className="mr-2" alt="Edit Icon" />
              {t('approverManagement.edit')}
            </Button>
          </Typography>
        </TableCell>
      );
    }

    if (column.id === 'region') {
      const regions = row.region?.split(',').map((r) => r.trim()) || [];
      return (
        <TableCell key={column.id} className="approver-management-table-cell">
          {regions.length > 5 ? (
            <Typography variant="body2" className="regions-text">
              {regions.slice(0, 6).join(', ')}{' '}
              <LightTooltip title={regions.join(', ')} className="tooltip-regions" arrow>
                <span className="read-more-text-regions">{t('speakerManagement.readMore')}</span>
              </LightTooltip>
            </Typography>
          ) : (
            <Typography variant="body2" className="regions-text">
              {regions.join(', ')}
            </Typography>
          )}
        </TableCell>
      );
    }

    const cellContent = row[column.id] || '';
    return (
      <TableCell key={column.id} className="approver-management-table-cell">
        {cellContent}
      </TableCell>
    );
  };

  const visibleRows =
    rowsData.length > 0
      ? sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : sortedRows;

  return (
    <>
      <TableBody className="approver-management-table-body">
        {visibleRows.map((row, index) => (
          <TableRow key={index} className="approver-management-table-row">
            {rowsHead.map((column) => renderCellContent(column, row))}
          </TableRow>
        ))}
        {emptyRows > 0 && (
          <TableRow style={{ height: 53 * emptyRows }}>
            <TableCell colSpan={rowsHead.length} />
          </TableRow>
        )}
      </TableBody>

      <ConfirmDialog
        open={deleteDialogOpen}
        text={t('approverManagement.deleteConfirmation', {
          name: selectedRow?.name || ''
        })}
        Icon={CancelIcon}
        successButtonText={t('button.yes')}
        cancelButtonText={t('button.no')}
        handleClose={handleDialogClose}
        handleYes={handleDialogConfirm}
        iconColor="red"
        cancelPopup="Yes"
      />
    </>
  );
};

export default ApproverListTableBody;
